/* zop-bridge.js (boolean flag only)
 * On any add-to-cart button click (form[action^="/cart/add"]) send a simple
 * boolean flag to Flutter InAppWebView handler 'ZopBridge'.
 */
(function () {
    if (window.ZopBridgeInitialized) return;
    window.ZopBridgeInitialized = true;

    const HANDLER_NAME = 'ZopBridge';

    function sendEvent(eventName) {
        try {
            if (window.flutter_inappwebview && typeof window.flutter_inappwebview.callHandler === 'function') {
                window.flutter_inappwebview.callHandler(HANDLER_NAME, {
                    event: eventName,
                    payload: { triggered: true }
                });
            }
        } catch (e) {
            // silent
        }
    }

    // Patch existing mini cart close handler if present
    function patchMiniCartClose() {
        try {
            if (typeof window.closeMiniCartDrawerHandler === 'function' && !window.__zopPatchedCloseMiniCart) {
                window.__zopPatchedCloseMiniCart = true;
                const orig = window.closeMiniCartDrawerHandler;
                window.closeMiniCartDrawerHandler = function () {
                    const res = orig.apply(this, arguments);
                    setTimeout(function () { sendEvent('cart_close') }, 25);
                    return res;
                };
            }
        } catch (e) {
            // silent
        }
    }
    function initBridgeEvents() {
        // Unified click handler with simple routing
        document.addEventListener('click', function (event) {
            // Close button(s) for cart drawer
            const closeBtn = event.target.closest('.cart-drawer__close,[data-cart-drawer-close],button[aria-controls="CartDrawer"][data-close]');
            if (closeBtn) {
                sendEvent('cart_close');
                return;
            }

            // Add to cart buttons inside product forms
            const addBtn = event.target.closest('form[action^="/cart/add"] [type="submit"]') || event.target.closest('form[action^="/cart/add"] [name="add"]');
            if (addBtn) {
                const form = addBtn.closest('form[action^="/cart/add"]');
                if (form) sendEvent('cart_open');
                return;
            }

            // Cart drawer open triggers
            const drawerBtn = event.target.closest('a.cart-drawer-button[aria-controls="CartDrawer"], button[aria-controls="CartDrawer"], [data-cart-drawer-trigger]');
            if (drawerBtn) {
                sendEvent('cart_open');
                return;
            }
        }, true);
    }


    document.addEventListener('DOMContentLoaded', function () {
        patchMiniCartClose();
        initBridgeEvents();
    });
})();
